export const assessmentConstants = {
   UPDATE_ASSESSMENT_REQUEST: 'UPDATE_ASSESSMENT_REQUEST',
   UPDATE_ASSESSMENT_SUCCESS: 'UPDATE_ASSESSMENT_SUCCESS',
   UPDATE_ASSESSMENT_FAILURE: 'UPDATE_ASSESSMENT_FAILURE'
};